import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const transition = {
  duration: 0.8,
  ease: [0.6, -0.5, 0.01, 0.9],
};

const lineGrow = {
  initial: { width: "100%" },
  animate: { width: 0 },
};

const titleSlideUp = {
  initial: { y: 200 },
  animate: { y: 0 },
};

const MenuList = ({ leftLineFlex, rightLineFlex, title, id }) => {
  const list = useRef(null);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [state, setState] = useState({
    top: 0,
    left: 0,
  });

  useEffect(() => {
    setState({
      top: list.current.getBoundingClientRect().top,
      left: list.current.getBoundingClientRect().left,
    });
  }, []);

  return (
    <motion.li ref={list}>
      <Link to={`/${id}`}>
        <div className="wrapper">
          <div className={`line left flex-${leftLineFlex}`}>
            <motion.div
              variants={lineGrow}
              className="mask"
              transition={{ ...transition, duration: 1 }}
            ></motion.div>
          </div>
          <motion.div className="title">
            <h2>
              <motion.div
                variants={titleSlideUp}
                transition={transition}
                className="text"
              >
                {title}
              </motion.div>
            </h2>
          </motion.div>
          <div className={`line right flex-${rightLineFlex}`}>
            <motion.div
              variants={lineGrow}
              className="mask right"
              transition={{ ...transition, duration: 1 }}
            ></motion.div>
          </div>
        </div>
      </Link>
    </motion.li>
  );
};

export default MenuList;
